export default "__VITE_ASSET__D$RaVdzN__"